import React from 'react';
import classnames from 'classnames';

import './Container.scss';

export default ({ displaySubNav, children, hideNavbar }) => {
  let className = '';

  if (!hideNavbar) {
    className = displaySubNav ? 'container-with-subnav' : 'container';
  }

  return <div className={classnames(className)}>{children}</div>;
};
